// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-progress-snackbar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  color: #1f1f1f;
}
.upload-progress-snackbar__header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  line-height: 1.2;
}
.upload-progress-snackbar__icon {
  color: #234e32;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.upload-progress-snackbar__title {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.upload-progress-snackbar__position {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
}
.upload-progress-snackbar__filename {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.upload-progress-snackbar__percent {
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
  font-weight: 600;
  color: #234e32;
  min-width: 40px;
  text-align: right;
}
.upload-progress-snackbar__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}
.upload-progress-snackbar__cancel {
  color: #234e32;
  min-width: auto;
  padding: 0 8px;
  line-height: 28px;
  font-size: 0.8125rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/upload-progress-snackbar/upload-progress-snackbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAGE;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAME;EACE,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AANJ","sourcesContent":[".upload-progress-snackbar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  width: 100%;\r\n  color: #1f1f1f;\r\n\r\n  &__header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 0.875rem;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  &__icon {\r\n    color: #234e32;\r\n    font-size: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  &__title {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  &__position {\r\n    font-size: 0.75rem;\r\n    color: #666;\r\n    font-weight: 500;\r\n  }\r\n\r\n  &__filename {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    font-weight: 600;\r\n  }\r\n\r\n  &__percent {\r\n    font-variant-numeric: tabular-nums;\r\n    flex-shrink: 0;\r\n    font-weight: 600;\r\n    color: #234e32;\r\n    min-width: 40px;\r\n    text-align: right;\r\n  }\r\n\r\n  &__actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 4px;\r\n  }\r\n\r\n  &__cancel {\r\n    color: #234e32;\r\n    min-width: auto;\r\n    padding: 0 8px;\r\n    line-height: 28px;\r\n    font-size: 0.8125rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
